'use strict'

const { createYConnection } = require('../../functions/createYConnection')

angular.module('rmRundown')
  .config(['$stateProvider', function ($stateProvider) {

    let editState = {
      url: '/edit/:type/:itemId/:blockId?',
      params: { blockId: null },
      views: {
        'rundown-edit@': {
          templateUrl: '/partial/app.partials.rundown.edit',
          controller: 'RundownEditCtrl',
          controllerAs: 'ctrl'
        }
      },
      onEnter: ['bladesManager', '$rootScope', function (bladesManager, $rootScope) {
        $rootScope.bladeManagerOnTop = true

        let loadedViews = bladesManager.all(1)
        let found = loadedViews.some(function (el) {
          return el.viewName === 'rundown-edit'
        })

        if (!found) {
          bladesManager.insert({
            viewName: 'rundown-edit',
            size: 'full-one-third',
            extraClasses: 'rundown'
          }, 1)
        }
      }],
      onExit: ['bladesManager', '$state', '$rootScope', function (bladesManager, $state, $rootScope) {
        $rootScope.bladeManagerOnTop = false

        if (!$state.includes('edit')) {
          bladesManager.removeRight('rundown-edit', 1)
        }
      }]
    }
    let editContactState = {
      url: '/contact/:contactId',
      params: {
        name: null,
        contactId: null
      },
      views: {
        'contact@': {
          templateUrl: '/partial/app.partials.contact.detail',
          controller: 'ContactFormCtrl',
          controllerAs: 'contactCtrl'
        }
      },
      onEnter: ['bladesManager', function (bladesManager) {
        let loadedViews = bladesManager.all(1)
        let found = loadedViews.some(function (el) {

          return el.viewName === 'contact'
        })

        if (!found) {

          bladesManager.insertRight({
            viewName: 'contact',
            size: 'full-one-third',
            extraClasses: 'rundown'
          }, 1)
        }
      }],
      onExit: ['$state', 'bladesManager', function ($state, bladesManager) {
        if (!/^rundown\.edit\.contact/.test($state.transition.to().name)) {
          bladesManager.removeRight('contact', 1)
        }
      }]
    }
    $stateProvider
      .state('rundown', {
        url: '/rundown/program-:program/broadcast-:broadcast?externalBroadcastId',
        params: {
          program: null
        },
        reloadOnSearch: false,
        resolve: {
          filterMap: ['$http', function ($http) {
            return $http.get('/userfilters/item').then((req) => {
              return req.data.userFilters
            })
          }],
          rundownInfo: ['$http', '$stateParams', function ($http, $stateParams) {
            return $http({
              url: '/broadcasts/rundowninfo',
              method: 'GET',
              params: {
                externalBroadcastId: $stateParams.externalBroadcastId,
                programId: $stateParams.program,
                broadcastId: $stateParams.broadcast
              }
            }).then(response => response.data)
          }],
          masterStationInfo: ['rundownInfo', function (rundownInfo) {
            const stationId = window.CONFIG.station_id
            const masterStationId = rundownInfo.masterstation_id || stationId
            const isMasterStation = masterStationId === stationId
            return { isMasterStation, masterStationId, stationId }
          }],
          itemModelTypes: ['$http', 'masterStationInfo', function ($http, masterStationInfo) {
            return $http.get(
              !masterStationInfo.isMasterStation
                ? `/modeltypes/masteritem/${masterStationInfo.masterStationId}`
                : '/modeltypes/item'
            )
              .then(response => response.data.item)
              .then(modelTypes => window.itemModelTypes = modelTypes)

          }],
          yConnection: ['rundownInfo', '$rootScope', '$mdDialog', (...args) => {
            return new (require('./y_connection')).default(...args)
          }],
          yDraftConnections: function () {
          },
        },
        onEnter: [
          'bladesManager',
          '$mdDialog',
          '$state',
          'rundownInfo',
          'yConnection',
          'masterStationInfo',
          'itemModelTypes',
          function (bladesManager, $mdDialog, $state, rundownInfo, yConnection, masterStationInfo, itemModelTypes) {
            bladesManager.clearAll()

            $mdDialog.show({
              templateUrl: '/partial/app.partials.rundown.overview',
              parent: angular.element('#rundownContainer'),
              controller: 'RundownOverviewCtrl',
              controllerAs: 'ctrl',
              locals: {
                rundownInfo: rundownInfo,
                yConnection: yConnection,
                masterStationInfo: masterStationInfo,
                itemModelTypes: itemModelTypes,
              },
              autoWrap: false,
              hasBackdrop: true,
              clickOutsideToClose: false,
              escapeToClose: false,
            }).then(function () {
              },
              function () {
                let name = bladesManager.getPreviousState().name || 'rundown'
                name = (name.indexOf('rundown') !== -1) ? name : 'rundown'
                $state.go(name)
              })
          },
        ],
        onExit: ['$mdDialog', 'widgets', function ($mdDialog, widgets) {
          console.log('close rundown')
          $mdDialog.hide()
          Object.keys(widgets.getConnectionsFromTypeId('rundown_tab'))
            .forEach(id => widgets.unRegisterWidget(id))
        }]
      })

      .state('rundown.edit', editState)

      .state('rundown.edit.contact', editContactState)

      .state('rundown.drafts', {
        url: '/drafts',
        views: {
          'drafts@': {
            templateUrl: '/partial/app.partials.rundown.drafts',
            controller: 'RundownDraftsCtrl',
            controllerAs: 'ctrl'
          }
        },
        resolve: {
          yDraftConnections: ['rundownInfo', function (rundownInfo) {
            const stationId = rundownInfo.masterstation_id || window.CONFIG.station_id
            const personal = createYConnection('rundown.personal.' + stationId + '.' + window.CONFIG.user_id)
            const program = createYConnection('rundown.program.' + stationId + '.' + rundownInfo.broadcast.program.id)
            const station = createYConnection('rundown.station.' + window.CONFIG.station_id + '.' + window.CONFIG.station_id)

            return Promise.all([personal, program, station])
              .then(yObjects => ({
                personal: yObjects[0],
                program: yObjects[1],
                station: yObjects[2]
              }))
          }],
        },
        reloadOnSearch: false,
      })

      .state('rundown.drafts.edit', angular.copy(editState))

      .state('rundown.drafts.edit.contact', angular.copy(editContactState))

      .state('rundown.widgets', {
        url: '/widgets/:widget',
        onEnter: ['widgets', '$stateParams', 'masterStationInfo', 'rundownInfo', 'elementReady', '$rootScope', function (widgets, $stateParams, masterStationInfo, rundownInfo, elementReady, $rootScope) {
          elementReady('.content-container > .rundownPreps-container').then(element => {
            const readOnly = element.attr('data-read-only') !== 'false' || !masterStationInfo.isMasterStation

            let container = element
            let widgetId = $stateParams.widget
            let widgetEl = container.find('#widget-' + widgetId)
            let uniqueWidgetId = 'rundown_tab_' + widgetId

            const broadcast = rundownInfo.broadcast
            const program = broadcast.program

            if (widgetEl.length === 0) {
              widgets.getWidgetById(widgetId, 'rundown_tab', rundownInfo.masterstation_id || window.CONFIG.station_id).then((widget) => {
                if (widget) {
                  widgets.createWidgetFrame(
                    uniqueWidgetId,
                    widget,
                    {
                      broadcastId: broadcast.id,
                      programId: broadcast.program.id
                    },
                    'rundown_tab',
                    data => $rootScope.$broadcast('rundown_tab_widget_message', widget, uniqueWidgetId, data),
                    () => ([
                      null,
                      { readOnly }
                    ]),
                    {
                      broadcast: broadcast,
                      program: program,
                    },
                    rundownInfo.masterstation_id || window.CONFIG.station_id,
                    undefined,
                    rundownInfo.masterstation_system_name,
                  ).then(newEl => {
                    newEl.id = 'widget-' + widgetId
                    newEl.className = 'widget'
                    container.append(newEl)
                    $rootScope.$broadcast('rundown_register_new_rundown_tab', widget, uniqueWidgetId, newEl)
                  })
                }
              })
            } else {
              widgetEl.removeClass('hidden')
            }

            widgets.sendMessage(uniqueWidgetId, 'focused')
          })
        }],
        onExit: ['$stateParams', 'widgets', function ($stateParams, widgets) {
          angular.element('#widget-' + $stateParams.widget).addClass('hidden')

          widgets.sendMessage('rundown_tab_' + $stateParams.widget, 'unfocused')
        }]
      })

      .state('rundown.widgets.edit', angular.copy(editState))

      .state('rundown.widgets.edit.contact', angular.copy(editContactState))

  }])
